import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        gridWrapper: {
            display: 'grid',
            gridGap: theme.spacing(2),
            gridTemplateColumns: 'repeat(2, 1fr)',
        },
        container: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
    }
})

export default useStyles
